module.exports = __webpack_public_path__ + "img/Comic01-2.654ba5b2.png";